import { atom } from "jotai";
import React from "react";
import { GroupListItem, NoGroupStudentListItem } from "../../../service/group";

//选中的小组id
export const groupIdAtom = atom(-1);

interface GroupSettingsProps {
    groupList: GroupListItem[] | null; //小组列表
    groupListLoading: boolean; //小组列表加载状态
    updateGroupList: () => Promise<void>; //小组列表更新函数
    setSearch: (val: string) => void; //小组列表成员查询条件
    filterNoGroupList: NoGroupStudentListItem[]; //未分组的成员列表
    noGroupLoading: boolean; //未分组的列表加载状态
    updateNoGroupStudent: () => Promise<void>; //未分组成员更新函数
    setNoGroupSearch: (val: string) => void; //未分组成员查询条件
}

export const GroupSettingsContext = React.createContext<GroupSettingsProps>({
    groupList: [],
    groupListLoading: false,
    updateGroupList: () => Promise.resolve(),
    setSearch: () => null,
    filterNoGroupList: [],
    noGroupLoading: false,
    updateNoGroupStudent: () => Promise.resolve(),
    setNoGroupSearch: () => null
});

export const FlagAtom = atom(false);
